// @file Get current tenant info
import window, { ww } from '@@/bits/global'
import { Tenant } from '@@/types'

const NATIVE_TENANT_ID = 1

// The Tenant might not be set on `window` if the scripts have not run.
const getCurrentTenant = (): Tenant => window.$currentTenant ?? ww?.vueStartingState?.tenant ?? { id: null }
export { NATIVE_TENANT_ID, getCurrentTenant }
